module.exports = __webpack_public_path__ + "media/images/page/voice_illust01-5dde6dfb08d6938b9bcb4bbcb5ff2eec.png";